import React, { useEffect, useState } from 'react';
import { EditProfileInfo, Header, ManagerHeader } from 'widgets';
import { useNavigate, useParams } from 'react-router-dom';
import { Loading } from 'pages/loading/ui/loading.page';
import { UserRoleEnum, userStore } from 'entities/index';
import { BusinessApi } from 'shared/api';
import { PageLayout } from 'shared/ui';

export const ManagerPage: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [fio, setFio] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [imgUrl, setImgUrl] = useState('');
  useEffect(() => {
    if (typeof id != 'string') {
      userStore.redirectToRoleBasedPage(navigate);
    } else {
      fetchUserData();
    }
  }, []);

  const fetchUserData = async () => {
    try {
      if (id) {
        const response = await BusinessApi.accountGetInfo({
          accountId: id,
          role: UserRoleEnum.MANAGER,
        });
        setFio(response.fio);
        setPhone(response.phone);
        setEmail(response.email);
        setImgUrl(response.imgUrl);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const updateData = async (email: string, fio: string, phone: string) => {
    if (id) {
      const response = await BusinessApi.updateManagerInfo({
        managerId: id,
        email,
        fio,
        phone,
      });
      setFio(response.fio);
      setPhone(response.phone);
      setEmail(response.email);
      setImgUrl(response.imgUrl);
    }
  };

  return id ? (
    <PageLayout>
      <Header />
      <ManagerHeader
        managerId={id}
        dataFio={fio}
        dataImgUrl={imgUrl}
        dataPhone={phone}
        dataEmail={email}
      />
      <EditProfileInfo
        dataFio={fio}
        dataEmail={email}
        dataPhone={phone}
        updateData={updateData}
      ></EditProfileInfo>
    </PageLayout>
  ) : (
    <Loading />
  );
};
